'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;
// import { pageQuery } from './service';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _select = require('../components/select');

var _select2 = _interopRequireDefault(_select);

var _formFieldUtils = require('../common/formFieldUtils');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var SelectField = (_temp = _class = function (_Field) {
  _inherits(SelectField, _Field);

  function SelectField(props) {
    _classCallCheck(this, SelectField);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    var dataSource = props.dataSource,
        fieldId = props.fieldId;

    _this.state = _extends({}, _this.state, {
      loading: false,
      current: 1,
      reload: false
    });
    return _this;
  }

  SelectField.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var superState = _Field.getDerivedStateFromProps.call(this, props, state);
    var resultState = _extends({}, superState);

    var dataSource = props.dataSource,
        onRequestOptions = props.onRequestOptions,
        _props$asyncOptions = props.asyncOptions,
        asyncOptions = _props$asyncOptions === undefined ? [] : _props$asyncOptions;

    var isAsyncData = dataSource.type === 'DATA';
    if (isAsyncData) {
      var prevOptions = state.options || [];
      var reload = state.reload;

      if (reload) {
        _extends(resultState, { options: asyncOptions });
      } else {
        var options = Object.values(_extends({}, (0, _lodash.keyBy)(prevOptions, 'value'), (0, _lodash.keyBy)(asyncOptions, 'value')));
        _extends(resultState, { options: options });
      }
    }

    return resultState;
  };

  // componentDidMount() {
  //   super.componentDidMount();
  //   const { dataSource, onRequestOptions } = this.props;
  //   if (dataSource.type === 'DATA') {
  //     onRequestOptions && onRequestOptions();
  //   }
  // }

  SelectField.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-select'
    });
  };

  SelectField.prototype.fetchData = function fetchData() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        pageIndex = _ref.pageIndex,
        pageSize = _ref.pageSize,
        keyword = _ref.keyword;

    var defaultRequest = null;
    if (((__ctx__.globalEvents[this.props.fieldId] || {}).onRequestOptions || []).length) {
      defaultRequest = (__ctx__.globalEvents[this.props.fieldId] || {}).onRequestOptions[0];
    }
    var _props = this.props,
        _props$onRequestOptio = _props.onRequestOptions,
        onRequestOptions = _props$onRequestOptio === undefined ? defaultRequest : _props$onRequestOptio,
        $state = _props.$state;

    var realData = (0, _lodash.omitBy)({ pageIndex: pageIndex, pageSize: pageSize, keyword: keyword }, _lodash.isNil);
    $state.setData(realData, true);
    onRequestOptions && onRequestOptions();
  };

  SelectField.prototype.getControlProps = function getControlProps() {
    var _this2 = this;

    var superControlProps = _Field.prototype.getControlProps.call(this);
    var _props2 = this.props,
        dataSource = _props2.dataSource,
        showSearch = _props2.showSearch;

    var options = this.getOptions();
    var controlProps = _extends({}, superControlProps, {
      dataSource: options,
      mode: 'single',
      showSearch: showSearch,
      useDetailValue: false // 开启对象值
    });

    if (dataSource.type === 'DATA') {
      _extends(controlProps, {
        lazyLoad: true,
        searchLocal: false,
        showSearch: true,
        onVisibleChange: function onVisibleChange(visible) {
          if (visible) {
            _this2.setState({ reload: true, current: 1 }, function () {
              _this2.fetchData({ keyword: '', pageIndex: 1 });
            });
          }
        },
        onSearchChange: function onSearchChange(keyword) {
          _this2.setState({ reload: true, current: 1 }, function () {
            _this2.fetchData({ keyword: keyword, pageIndex: 1 });
          });
        },
        onLoadMore: function onLoadMore() {
          var current = _this2.state.current;
          var _props3 = _this2.props,
              total = _props3.total,
              pageSize = _props3.pageSize;

          var pageIndex = current + 1;
          if (total > 0 && current * pageSize >= total) {
            return false;
          }
          _this2.setState({ reload: false, current: pageIndex }, function () {
            _this2.fetchData({ pageIndex: pageIndex });
          });
        }
      });
    }
    return controlProps;
  };

  SelectField.prototype.renderControl = function renderControl() {
    var loading = this.state.loading;

    var controlProps = this.getControlProps();

    return _react2.default.createElement(_select2.default, _extends({}, controlProps, { loading: loading }));
  };

  return SelectField;
}(_vuFusionField2.default), _class.displayName = 'Select', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, { showSearch: false, pageSize: 10, needCompleteOptions: true }), _class.Store = _vuFusionField2.default.Store, _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), ['dataSource', {
  name: 'fieldData',
  formatIn: function formatIn() {
    var fieldData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var props = arguments[1];
    var states = arguments[2];
    var dataType = arguments[3];

    var defaultItems = (0, _formFieldUtils.getDefaultOptions)(states.options.value);
    if (!(0, _lodash.isEmpty)(fieldData.value)) {
      return fieldData;
    } else {
      states.fieldData.value = defaultItems[0];
      return _extends({}, fieldData, { value: defaultItems[0] });
    }
  }
}]), _temp);
exports.default = SelectField;
module.exports = exports['default'];